import { useState } from "react";
import { TextField, Button } from "@mui/material";
import RadioGrup from "../../utils/form/RadioGrup";
import { Controller } from "react-hook-form";
import ContentInput from "../utils/medicalDocument/templates/ContentInput";
import { ErrorAlert, Alert } from "../../utils";
import _ from "lodash";

const NameHelperText = ({ type }) => (
  <span>
    Debe ser único. Por ejemplo:{" "}
    {type === "prescription" ? "Medicacion HTA 1" : "RMN Cerebro simple"}
  </span>
);

const FormtTemplate = ({ form, onSubmitOperation, type }) => {
  const { control, handleSubmit, watch, reset } = form;
  const [error, setError] = useState(false);
  const [shared, setShared] = useState(false);

  const optionsType = [
    { label: "Orden", value: "order" },
    { label: "Receta", value: "prescription" },
  ];

  const onSubmit = (templateDto) => {
    onSubmitOperation({ type, templateDto })
      .tap(() => reset())
      .tap(() => setShared(true))
      .catch(setError);
  };

  const onSubmitWithoutPropagation = (e) => {
    e.preventDefault();
    e.stopPropagation();
    handleSubmit(onSubmit)(e);
  };

  const errorMessage = _.chain(error)
    .get("response.data.message.detail")
    .includes("unique")
    .value()
    ? "Ya existe una plantilla con este nombre"
    : "No se pudo crear la plantilla";

  return (
    <>
      <form autoComplete="off" onSubmit={onSubmitWithoutPropagation}>
        <Controller
          name="type"
          control={control}
          render={({ field }) => (
            <RadioGrup
              options={optionsType}
              method={field.value}
              handleChange={field.onChange}
            />
          )}
        />

        <Controller
          name="name"
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              label="Nombre de plantilla"
              variant="outlined"
              required
              helperText={<NameHelperText type={type} />}
              style={{ width: "100%" }}
            />
          )}
        />

        <ContentInput
          form={form}
          originalTemplate={form.getValues()}
          type={type}
          checkMargin={3}
        />

        <Button variant="contained" type="submit">
          Crear Plantilla
        </Button>
      </form>
      <ErrorAlert
        show={!_.isEmpty(error)}
        onClose={() => setError(null)}
        message={errorMessage}
      />
      <Alert
        severity="success"
        message="¡Plantila creada con éxito!"
        onClose={() => setShared(false)}
        show={shared}
      />
    </>
  );
};

export default FormtTemplate;
